import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'

export const loadRegions = createLogic({
  type: constants.LOAD_REGIONS.ACTION,
  processOptions: {
    successType: constants.LOAD_REGIONS.FULFILLED,
    failType: constants.LOAD_REGIONS.REJECTED
  },

  process({ http }) {

  return http
      .get('/comps/projects/regions')
      .pipe(map(http.getBody))
  }
})
